import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { useTranslation } from 'react-i18next'

import { truncate } from 'utils/strings'
import colors from 'components/utils/colors'
import MarkedText from 'components/Shared/MarkedText/Index'

const styleAsBold = css`
  font-weight: 600;
`

const styleAsNoData = css`
  color: ${colors.secondary70};
`

const StyledText = styled.section`
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
  color: ${colors.secondary20};
  word-break: break-word;
  margin-right: 17px;
  display: flex;
  align-items: center;

  ${props => props.bold && styleAsBold}
  ${props => props.noData && styleAsNoData}
`

const SidebarText = ({ text, truncateLength, className, bold, markedPart }) => {
  const { t } = useTranslation()
  const noData = !text && text !== 0
  let fieldText = noData ? t('sidebar.noData') : text

  if (!noData && truncateLength > 0) {
    fieldText = truncate(fieldText, truncateLength)
  }

  return (
    <StyledText bold={bold} noData={noData} className={className}>
      <MarkedText text={fieldText} markedPart={markedPart} />
    </StyledText>
  )
}

SidebarText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  truncateLength: PropTypes.number,
  bold: PropTypes.bool,
  markedPart: PropTypes.string,
}

export default SidebarText
